// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2ba51dba","703":"767ac9da","736":"5d3ebcba","974":"2a549974"}[chunkId] + ".chunk.js";
};